<template>
  <div class="news" v-if="isShow">
    <div class="dynamic-box-top">
      <div v-show="!messageDetails" class="top-left">
        {{ $t("homeFirst.Activity") }}
      </div>
      <div
        @click="messageDetails = false"
        v-show="messageDetails"
        class="top-left arrowa"
      >
        <div class="arrow-box">
          <svg-btn class="right-time" icon-class="icon-arrow-right"></svg-btn>
        </div>
        {{ $t("homeFirst.MoreActivity") }}
      </div>
      <div class="top-right">
        <div class="left-time1">
          <div
            :class="$store.state.actIndex == 1 ? 'actIndexact' : ''"
            class="act"
            @click="actIndexFn(1)"
          >
            {{ $t("homeFirst.ThisMonth") }}
          </div>
          <div
            :class="$store.state.actIndex == 2 ? 'actIndexact' : ''"
            class="act"
            @click="actIndexFn(2)"
          >
            {{ $t("homeFirst.LastMonths") }}
          </div>
        </div>
        <div class="svg-box" @click="showdynamicSetting = true">
          <svg-btn class="right-time1" icon-class="icon-account"></svg-btn>
        </div>
      </div>
    </div>
    <!-- 消息类型 -->
    <div
      ref="scrollBox"
      :style="{ paddingRight: scrollBoxPaddingRight }"
      class="message-list"
      v-show="!messageDetails"
    >
      <!-- 转存文件消息 -->
      <div
        v-for="(item, index) in messagelist"
        :key="index"
        class="message-item"
        @click="messageFn(item)"
      >
        <div
          :style="{ boxShadow: item.count == 1 ? 'none' : '' }"
          class="item-1"
        >
          <div class="info-box">
            <div class="icon">
              <img class="icon-img" :src="item.icon" alt="" srcset="" />
            </div>
            <div class="text-box">
              <div class="text1">
                <span class="type">{{ item.type_name }}</span>
                <span class="title">
                  {{ item.title }}
                </span>
              </div>
              <div class="text2">
                <div class="type" v-for="items in item.content" :key="items"  v-html="items.replace(/\n/g, '<br>')">
                </div>
              </div>
              <div class="time-box">
                <div class="time">{{ item.create_time }}</div>
              </div>
            </div>
          </div>
          <svg-btn
            class="bot-zhankai"
            icon-class="icon-zhankai"
          ></svg-btn>
        </div>
        <div v-if="item.count > 1" class="item-2"></div>
        <div v-if="item.count > 2" class="item-3"></div>
      </div>

      <div class="Dynamic_default" v-show="messagelist.length <= 0">
        <img
          class="icon_Dynamic_default"
          :src="$utils.getPng('icon_Dynamic_default')"
          default
          alt=""
          srcset=""
        />
        <div class="icon_Dynami">暂无动态</div>
      </div>
    </div>

    <div
      ref="scrollBox2"
      :style="{ paddingRight: scrollBox2PaddingRight }"
      class="message-list"
      v-show="messageDetails"
      @scroll="scrollBox2Fun()"
    >
      <!-- 转存文件消息 -->
      <div
        v-for="(item, index) in messagelist2"
        :key="index"
        class="message-item"
        :class="{ isMtid42: item.mtid == '42' }"
        @click="messageFn2(item)"
      >
        <div :style="{ boxShadow: 'none' }" class="item-1">
          <div class="info-box">
            <div :class="item?.fshort ? 'icon2' : 'icon'">
              <img class="icon-img" :src="item.icon" alt="" srcset="" />
            </div>
            <div class="text-box">
              <div class="text1">
                <span class="type">{{ item.type_name }}</span>
                <span class="title">
                  {{ item.title }}
                </span>
              </div>
              <div class="text2-title" v-if="item.content_title">
                {{ item.content_title }}
              </div>
              <div class="text22">
                <div class="type" v-for="items in item.content" :key="items"  v-html="items.replace(/\n/g, '<br>')">
                </div>
              </div>
              <div v-if="item?.content_img" class="text3">
                <img :src="item.content_img" alt="" srcset="" />
              </div>
              <div class="time-box">
                <div class="time">{{ item.create_time }}</div>
              </div>
            </div>
          </div>
          <svg-btn
            v-if="![5, 6, 7, 8].includes(+item.type) && !(item.type == 9 && !item?.jump_url)"
            class="bot-zhankai"
            icon-class="icon-zhankai"
          ></svg-btn>
        </div>
      </div>

      <div
        class="Dynamic_default"
        v-show="messagelist2.length <= 0 && !loading"
      >
        <img
          class="icon_Dynamic_default"
          :src="$utils.getPng('icon_Dynamic_default')"
          default
          alt=""
          srcset=""
        />
        <div class="icon_Dynami">暂无动态</div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading-box">
        <div class="loading-spinner"></div>
        <span class="loading-text">加载中...</span>
      </div>

      <!-- 无更多数据提示 -->
      <div v-if="!hasMore && messagelist2.length > 0" class="no-more-box">
        <div class="no-more-text">
          {{
            actIndex === 1
              ? "已加载本月动态，可切换查看近三个月动态"
              : "暂无更多动态，最多展示近三个月动态"
          }}
        </div>
      </div>
    </div>

    <dynamicSetting
      :isShow="showdynamicSetting"
      @handleClose="showdynamicSetting = false"
      @SwitchObj="SwitchObjFn"
    ></dynamicSetting>
  </div>
</template>

<script>
import { webHome, getDynamicDetails } from "@/utils/apiList/usermsg";
import dynamicSetting from "@/components/dynamicSetting/index.vue";
export default {
  components: { dynamicSetting },
  name: "base",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageDetails: false,
      actIndex: 1,
      messagelist: [],
      messagelist2: [],
      showdynamicSetting: false,
      page: 1,
      page2: 1,
      pageSize: 5,
      total: 0,
      total2: 0,
      loading: false,
      loading2: false,
      hasMore: true,
      scrollBoxPaddingRight: "20px",
      scrollBox2PaddingRight: "20px",
    };
  },
  watch: {
    messageDetails(newVal, oldVal) {
      if (!newVal) {
        // this.messagelist = [];
        this.webHomeFn();
      }
    },
    isShow(newVal, oldVal) {
      if (newVal) {
        this.webHomeFn();
      }
    },
    "$store.state.actIndex"(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.messageDetails) {
          this.page = 1;
          this.hasMore = true;
          this.loading = false;
          this.getDynamicDetailsFn();
        } else {
          this.webHomeFn();
        }
      }
    },
  },
  mounted() {
    if (this.$utils.getCookie(this.$glb.fmCookieName)) {
      this.webHomeFn();
    }
    // 组件挂载后检测滚动条
    this.updateScrollBoxPadding();

    // 监听窗口大小变化
    window.addEventListener("resize", this.updateScrollBoxPadding);
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener("resize", this.updateScrollBoxPadding);
  },
  methods: {
    // 检测元素是否有滚动条
    hasScrollbar(element) {
      if (!element) return false;
      return element.scrollHeight > element.clientHeight;
    },

    // 更新滚动框的paddingRight
    updateScrollBoxPadding() {
      this.$nextTick(() => {
        // 检测scrollBox
        if (this.$refs.scrollBox) {
          this.scrollBoxPaddingRight = this.hasScrollbar(this.$refs.scrollBox)
            ? "13.3px"
            : "20px";
        }

        // 检测scrollBox2
        if (this.$refs.scrollBox2) {
          this.scrollBox2PaddingRight = this.hasScrollbar(this.$refs.scrollBox2)
            ? "13.3px"
            : "20px";
        }
      });
    },

    SwitchObjFn() {
      if (this.messageDetails) {
        this.messageDetails = false;
      } else {
        this.messagelist = [];
        this.webHomeFn();
      }
    },
    actIndexFn(index) {
      this.actIndex = index;
      this.$store.commit("setAttr", {
        name: "actIndex",
        val: index,
      });
      localStorage.setItem('actIndex', index)

      // 重置滚动高度为0
      if (this.$refs.scrollBox) {
        this.$refs.scrollBox.scrollTop = 0;
      }
      if (this.$refs.scrollBox2) {
        this.$refs.scrollBox2.scrollTop = 0;
      }
    },
    scrollBox2Fun() {
      const scrollBox = this.$refs.scrollBox2;
      if (!scrollBox) return;

      // 检查是否滚动到底部
      const scrollTop = scrollBox.scrollTop;
      const scrollHeight = scrollBox.scrollHeight;
      const clientHeight = scrollBox.clientHeight;

      // 当滚动到距离底部50px以内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.loadMoreData();
      }
    },
    loadMoreData() {
      // 如果正在加载或没有更多数据，则不执行
      if (this.loading || !this.hasMore) {
        return;
      }

      this.getDynamicDetailsFn();
    },
    messageFn(item) {
      const validTypes = new Set([10, 11, 12, 14, 15]);
      const validTypes2 = new Set([1, 4, 17]);
      const validTypes3 = new Set([9, 21]);
      const validTypes4 = new Set([5, 6, 7, 8]);
      if (validTypes4.has(+item.type) && item.count == 1) {
        this.$toast("请前往Feemoo APP-设备管理查看", 2);
        return;
      } else if (validTypes.has(+item.type) && item.count == 1) {
        this.$router.push({ path: "/vip" });
      } else if (item.type == 16 && item.count == 1) {
        this.$router.push({ path: "/recycle" });
      } else if ((item.type == 2 || item.type == 3) && item.count == 1) {
        this.$router.push({ path: "/collectionSet" });
      } else if (item.type == 18 && item.count == 1) {
        this.$router.push({ path: "/myCollection" });
      }else if ((item.type == 19 || item.type == 20) && item.count == 1) {
        this.$router.push({ path: "/collectionShort" });
      } else if (item.type == 13 && item.count == 1) {
        // 跳转到对应的下载页
        sessionStorage.setItem("isFromShareList", 1);
        if (item?.go_url) {
          this.$router.push({
            path:
              "/s/" +
              item.fshort +
              "?pucode=" +
              item?.go_url +
              "#取件码：" +
              item?.go_url,
          });
        } else {
          this.$router.push({ path: "/s/" + item.fshort });
        }
      } else if (validTypes2.has(+item.type) && item.count == 1) {
        // 点击后跳转至文件-文件所在路径
        this.foldergo(item.folder_id, item.folder_name);
      } else if (validTypes3.has(+item.type) && item.count == 1) {
        // if (item?.mtid == 6) { 产品说要改成进去更多动态列表然后点击再提示
        //   this.$toast("请前往Feemoo APP-福利社-查看卡卷包", 2);
        //   return;
        // }
        this.page = 1;
        this.hasMore = true;
        this.loading = false;
        this.getDynamicDetailsFn(item.type);
      } else {
        this.page = 1;
        this.hasMore = true;
        this.loading = false;
        this.getDynamicDetailsFn(item.type);
      }
    },
    messageFn2(item) {
      const validTypes = new Set([10, 11, 12, 14, 15]);
      const validTypes2 = new Set([1, 4, 17]);
      const validTypes3 = new Set([9, 21]);
      const validTypes4 = new Set([5, 6, 7, 8]);
      if (validTypes4.has(+item.type)) {
        this.$toast("请前往Feemoo APP-设备管理查看", 2);
        return;
      } else if (validTypes.has(+item.type)) {
        this.$router.push({ path: "/vip" });
      } else if (item.type == 16) {
        this.$router.push({ path: "/recycle" });
      } else if (item.type == 2 || item.type == 3) {
        this.$router.push({ path: "/collectionSet" });
      } else if (item.type == 18) {
        this.$router.push({ path: "/myCollection" });
      }else if(item.type == 19 || item.type == 20){
        this.$router.push({ path: "/collectionShort" });
      } else if (item.type == 13) {
        // 跳转到对应的下载页
        sessionStorage.setItem("isFromShareList", 1);
        if (item?.go_url) {
          this.$router.push({
            path:
              "/s/" +
              item.fshort +
              "?pucode=" +
              item?.go_url +
              "#取件码：" +
              item?.go_url,
          });
        } else {
          this.$router.push({ path: "/s/" + item.fshort });
        }
      } else if (validTypes2.has(+item.type)) {
        // 点击后跳转至文件-文件所在路径
        this.foldergo(item.folder_id, item.folder_name);
      } else {
        if (validTypes3.has(+item.type)) {
          if (item?.mtid == 6) {
            this.$toast("请前往Feemoo APP-福利社-查看卡卷包", 2);
            return;
          }
          if (item?.jump_url) {
            window.open(item.jump_url, "_blank");
          }
        }
      }
    },
    webHomeFn() {
      this.actIndex = this.$store.state.actIndex;
      webHome({ date: this.actIndex }).then((res) => {
        if (res.status == 1) {
          this.messagelist = res.data.dynamic;
          // 数据更新后检测滚动条
          this.updateScrollBoxPadding();
        }
      });
    },
    getDynamicDetailsFn(type) {
      if (type) this.typess = type;

      // 如果正在加载或没有更多数据，则不执行
      if (this.loading || !this.hasMore) {
        return Promise.resolve();
      }

      this.loading = true;
      this.actIndex = this.$store.state.actIndex;
      const params = {
        page: this.page,
        limit: 30,
        type: this.typess,
        date: this.actIndex,
      };
      return getDynamicDetails(params)
        .then((res) => {
          this.loading = false;
          if (res.status == 1) {
            // 如果是第一页，替换数据；否则追加数据
            if (this.page === 1) {
              this.messagelist2 = res.data.list;
              this.hasMore = res.data.list.length >= 30; // 如果返回的数据少于限制数量，说明没有更多数据
              this.messageDetails = true;
            } else {
              this.messagelist2 = [...this.messagelist2, ...res.data.list];
              // 如果返回的数据少于限制数量，说明没有更多数据
              if (res.data.list.length < 30) {
                this.hasMore = false;
              }
            }
            this.page++;
            // 数据更新后检测滚动条
            this.updateScrollBoxPadding();
          } else {
            this.hasMore = false;
          }
          return res;
        })
        .catch((error) => {
          this.loading = false;
          this.hasMore = false;
          console.error("获取动态详情失败:", error);
          return Promise.reject(error);
        });
    },
    foldergo(folder_id, folder_name) {
      const folderData = {
        folder_id: folder_id || 0,
        name: folder_name || "",
        action: "openFolder", // 标识需要执行openFolder操作
      };

      if (folder_id != 0) {
        localStorage.setItem("openFolder", JSON.stringify(folderData));
      }
      this.$router.push({ path: "/files" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../Dialog/dialog.scss";
// @import "./index.scss";
.news {
  width: 396px;
  height: 520px;
  @include useTheme {
    background-color: getVar("background-color-272727");
  }
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 24px;
  @include useTheme {
    border: getVar("border-color2-ffffff");
  }
  backdrop-filter: blur(16px);
  padding: 17px 0 0 20px;
  cursor: auto;

  .dynamic-box-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 24px;

    .top-left {
      font-weight: 600;
      font-size: 14px;
      @include useTheme {
        color: getVar("text-color1-2c2c2c");
      }
      line-height: 22px;
    }

    .arrowa {
      font-weight: 500;
      font-size: 14px;
      @include useTheme {
        color: getVar("text-color1-8a8b92");
      }
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .arrow-box {
        width: 24px;
        height: 24px;
        border-radius: 6px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 12px;
        @include useTheme {
          color: getVar("text-color1-8a8b92");
        }
        line-height: 22px;
        &:hover {
          @include useTheme {
            background-color: getVar("bg-color-ebebeb");
          }
          cursor: pointer;
        }

        .right-time {
          width: 16px;
          height: 16px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
          transform: rotate(180deg);
        }
      }
    }

    .top-right {
      display: flex;
      align-items: center;

      .left-time1 {
        display: flex;
        align-items: center;
        padding: 0 3px;
        // width: 120px;
        height: 28px;
        @include useTheme {
          background-color: getVar("bg-color-ebebeb");
        }
        border-radius: 20px;

        .act {
          display: flex;
          align-items: center;
          padding: 0 12px;
          font-weight: 400;
          font-size: 11px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
          line-height: 20px;
          cursor: pointer;

          &:hover {
            @include useTheme {
              color: getVar("text-color1-2c2c2c");
            }
          }
        }

        .actIndexact {
          height: 22px;
          @include useTheme {
            color: getVar("text-color1-2c2c2c");
          }
          @include useTheme {
            background-color: getVar("bg-color-fill1");
          }
          border-radius: 20px;
        }
      }

      .svg-box {
        width: 24px;
        height: 24px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        cursor: pointer;

        &:hover {
          @include useTheme {
            background-color: getVar("bg-color-ebebeb");
          }
        }
        .right-time1 {
          width: 16px;
          height: 16px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
        }
      }
    }
  }

  .message-list {
    height: 456px;
    margin-top: 13px;
    display: flex;
    flex-direction: column;
    padding-right: 13px;
    overflow: auto;
    padding-bottom: 64px;
    // gap: 12px;

    .message-item {
      position: relative;
      margin-bottom: 10px;
      padding-top: 2px;

      .item-1 {
        position: relative;
        padding: 14px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill1");
        }
        border-radius: 18px;
        z-index: 10;
        box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        position: relative;

        .bot-zhankai {
          width: 16px;
          height: 8px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 2px;
          @include useTheme {
            color: getVar("text-color1-e5e5e5");
          }
        }

        .info-box {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          .icon {
            width: 36px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;

            .icon-img {
              width: 36px;
              height: 36px;
              border-radius: 50%;
            }
          }
          .icon2 {
            width: 36px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0; /* 防止被压缩 */
            min-width: 36px; /* 确保最小宽度 */
            box-sizing: border-box; /* 确保盒模型正确 */

            .icon-img {
              width: 32px;
              height: 32px;
            }
          }
          .text-box {
            display: flex;
            justify-content: center;
            flex-direction: column;
            word-break: break-all;
            word-wrap: break-word;
            overflow-wrap: break-word;
            .text1 {
              display: flex;
              margin-left: 8px;

              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 18px;
              .type {
                font-weight: 500;
                font-size: 13px;
                @include useTheme {
                  color: getVar("text-color1-2c2c2c");
                }
                line-height: 18px;
                margin-right: 6px;
              }
              .title {
                font-weight: 400;
                font-size: 13px;
                @include useTheme {
                  color: getVar("text-color1-2c2c2c");
                }
                line-height: 18px;
              }
            }

            .text2-title {
              margin-left: 8px;
              font-weight: 400;
              font-size: 13px;
              margin-top: 2px;
              @include useTheme {
                color: getVar("text-color1-2c2c2c");
              }
              line-height: 18px;
              word-break: break-all;
              word-wrap: break-word;
              overflow-wrap: break-word;
              max-width: calc(100% - 8px);
            }

            .text2 {
              margin-top: 2px;
              margin-left: 8px;
              max-width: calc(100% - 8px);

              .type {
                font-weight: 400;
                font-size: 11px;
                @include useTheme {
                  color: getVar("text-color1-52565a");
                }
                line-height: 16px;
                /* 添加以下属性实现两行缩略 */
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;

                word-break: break-all;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
            }
            .text22 {
              margin-top: 2px;
              margin-left: 8px;
              max-width: calc(100% - 8px);

              .type {
                font-weight: 400;
                font-size: 11px;
                @include useTheme {
                  color: getVar("text-color1-52565a");
                }
                line-height: 16px;
                /* 添加以下属性实现两行缩略 */
                // display: -webkit-box;
                // -webkit-line-clamp: 2;
                // line-clamp: 2;
                // -webkit-box-orient: vertical;
                // overflow: hidden;
                // text-overflow: ellipsis;
                word-break: break-all;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
            }
            .text3 {
              width: 212px;
              height: 118px;
              margin-top: 4px;
              margin-bottom: 4px;
              margin-left: 8px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .time-box {
              margin-top: 2px;
              margin-left: 8px;
              display: flex;
              align-items: center;
              .time {
                font-weight: 400;
                font-size: 11px;
                @include useTheme {
                  color: getVar("text-color1-8a8b92");
                }
                line-height: 16px;
                flex-shrink: 0;
              }
            }
          }
        }
      }
      .item-2 {
        position: relative;
        margin: -24px 8px 0 8px;
        padding: 14px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill12");
        }
        border-radius: 18px;
        z-index: 9;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04),
          0px 1px 8px -1px rgba(0, 0, 0, 0.02);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .item-3 {
        position: relative;
        margin: -24px 16px 0 16px;
        padding: 14px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill13");
        }
        border-radius: 18px;
        z-index: 8;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04),
          0px 1px 8px -1px rgba(0, 0, 0, 0.02);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .Dynamic_default {
      margin: auto;
      margin-top: 140px;
      text-align: center;

      .icon_Dynamic_default {
        width: 88px;
        height: 88px;
      }

      .icon_Dynami {
        font-size: 12px;
        line-height: 20px;
        margin-top: 4px;
        @include useTheme {
          color: getVar("text-color1-2c2c2c");
        }
      }
    }
    .message-item.isMtid42{
      .info-box {
        width: calc(100% - 36px);
        .text-box{
          width: 100%;
          .text22{
            .type{
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }

  // 加载状态样式
  .loading-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;

    .loading-spinner {
      width: 20px;
      height: 20px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid #f67942;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 8px;
    }

    .loading-text {
      font-size: 12px;
      color: #8a8b92;
    }
  }

  // 无更多数据样式
  .no-more-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 6px;
    // padding: 20px;

    .no-more-text {
      font-size: 12px;
      color: #8a8b92;
      text-align: center;
      line-height: 1.4;
    }
  }

  // 加载动画
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
